import { RefObject, useEffect, useRef } from "react";

/**
 * Scrolls the anchor into view when the active form changes and loading finishes.
 * Uses scrollIntoView so any overflow:auto ancestor resets correctly (not just window).
 */
export function useScrollToTopOnFormChange(
  anchorRef: RefObject<HTMLElement | null>,
  formId: string | undefined,
  isLoading: boolean,
) {
  const previousFormIdRef = useRef<string | undefined>();

  useEffect(() => {
    if (isLoading || !formId) {
      return;
    }
    if (previousFormIdRef.current === formId) {
      return;
    }
    previousFormIdRef.current = formId;

    const frame = requestAnimationFrame(() => {
      anchorRef.current?.scrollIntoView({ block: "start" });
    });
    return () => cancelAnimationFrame(frame);
  }, [formId, isLoading, anchorRef]);
}
